import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Pill } from "@/components/admin/AdminUI";
import { offerLine } from "@/components/admin/PromotionDialog";
import { api } from "@/lib/api";

function Result({ r }) {
  const offers = r.catalog?.offers || [];
  return (
    <div className="space-y-4" data-testid="promo-preview-result">
      <div className="flex flex-wrap gap-2">
        <Pill tone={r.matches_audience ? "success" : "neutral"} data-testid="promo-preview-match">{r.matches_audience ? "In the audience" : "Not in the audience"}</Pill>
        <Pill className="capitalize">Promotion: {r.state}</Pill><Pill className="capitalize">Tier: {r.tier}</Pill>
      </div>
      <div>
        <p className="text-sm font-semibold">Offers on their paywall ({offers.length})</p>
        {offers.length ? <ul className="mt-2 space-y-2" data-testid="promo-preview-offers">{offers.map((o, i) => (
          <li key={i} className="rounded-xl bg-[var(--cw-surface-tertiary)] px-4 py-3 text-sm"><p className="font-medium">{offerLine(o)}</p><p className="cw-soft text-xs">{o.promotion_name} · {o.ends_line}</p></li>
        ))}</ul> : <p className="cw-muted mt-1 text-sm">None right now. Offers only show while a scheduled promotion is live and the promotions flag is on.</p>}
      </div>
      <details className="text-xs"><summary className="cw-soft cursor-pointer">Full catalog as this user</summary>
        <pre className="mt-2 max-h-64 overflow-auto rounded-xl bg-[var(--cw-surface-tertiary)] p-3">{JSON.stringify(r.catalog, null, 2)}</pre></details>
    </div>
  );
}

export default function PromoPreviewDialog({ promo, onOpenChange }) {
  const [uid, setUid] = useState("");
  const [res, setRes] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.preventDefault();
    setBusy(true); setError(null); setRes(null);
    try { setRes(await api(`/admin/promotions/${promo.id}/preview?user_id=${encodeURIComponent(uid.trim())}`)); } catch (err) { setError(err.message); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!promo} onOpenChange={(o) => { if (!o) { setRes(null); setError(null); } onOpenChange(o); }}>
      <DialogContent className="max-h-[90vh] overflow-y-auto rounded-[20px] sm:max-w-lg" data-testid="promo-preview-dialog">
        <DialogHeader><DialogTitle>Preview “{promo?.name}” as a user</DialogTitle><DialogDescription>Shows the store catalog exactly as the app would get it for this person.</DialogDescription></DialogHeader>
        <form onSubmit={run} className="flex items-end gap-2">
          <div className="flex-1"><Label htmlFor="pp-uid">User ID</Label><Input id="pp-uid" value={uid} onChange={(e) => setUid(e.target.value)} className="mt-2 font-mono text-sm" data-testid="promo-preview-user-input" /></div>
          <Button type="submit" disabled={uid.trim().length !== 24 || busy} data-testid="promo-preview-run-button">{busy ? "Loading…" : "Preview"}</Button>
        </form>
        {error && <p className="cw-error text-sm" role="alert" data-testid="promo-preview-error">{error}</p>}
        {res && <Result r={res} />}
      </DialogContent>
    </Dialog>
  );
}
